// This file was automatically generated from appchart.refpanel.history.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.history');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.smokingStatuses');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.history.smokingStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldShortLabelPadding relative mb5"><label class="el8label el8LHSSubLabelGray" style="top:1px;">Smoking:</label><div class="el8FieldLongLabelPadding"><ol><li class="el8BulletText el8ItemHover smoking-status-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><span class="edit-text-trigger smoking-status-trigger el8EditableText">');
  el8.template.ptdata.smokingStatuses.summary(opt_data, output);
  output.append('<span class="el8EditIcon"></span></span></li></ol></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.history.smokingStatusButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldShortLabelPadding relative mb5"><label class="el8label el8LHSSubLabelGray">Smoking:</label><div class="el8FieldLongLabelPadding"><button type="button" class="el8button smoking-status-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Add Smoking Status</button></div></div>');
  if (!opt_sb) return output.toString();
};
